const CampaignZoneCell = ({ zoneLabel, flowLabel }) => {
  const displayZone = zoneLabel?.trim() || null;
  const displayFlow = flowLabel?.trim() || null;

  if (!displayZone && !displayFlow) {
    return <span className="text-sm text-[#222222] leading-[22px]">-</span>;
  }

  return (
    <span
      className="inline-flex items-baseline min-w-0 max-w-full gap-x-1.5 text-sm leading-[22px]"
      title={[displayZone, displayFlow].filter(Boolean).join(" · ")}
    >
      {displayZone ? (
        <span className="text-[#5e5e5e] truncate">{displayZone}</span>
      ) : null}
      {displayZone && displayFlow ? (
        <span className="text-[#5e5e5e] shrink-0" aria-hidden="true">
          ·
        </span>
      ) : null}
      {displayFlow ? (
        <span className="text-[#5e5e5e] truncate">{displayFlow}</span>
      ) : null}
    </span>
  );
};

export default CampaignZoneCell;
